export default "__VITE_ASSET__DHAWZsnq__"